export default "__VITE_ASSET__BprXXnvG__"